module.exports = __webpack_public_path__ + "static/media/bg3.c5c640bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AffiliateWelcome/SectionHero/HeroSection/bg3.jpg
// module id = 1829
// module chunks = 0